import React from 'react';
import { createContext, ReactNode, useCallback, useContext, useState } from 'react';
import { UserLoginData } from '../../TypeScript/interfaces';

//Context 
//contains data(UserLoginData) and function to change the data (setUserLoginData)
export type LoginData = {
  userLoginData: Partial<UserLoginData>;  
  setUserLoginData: (userLoginData:UserLoginData) => void;
};

//This is called when the context is used. 
//There is the data itself and function to amend the data
export const useUserLoginData = () => {
  const context = useContext(LoginContext);

  if (!context) {
    throw new Error('useUserLoginData must be used within LoginProvider');
  }  
  return context;
};

//Here is created the initial context
//The context can be either NULL or UploadData see the definotion of the type above
const LoginContext = createContext<LoginData | null>( null );

type ProviderProps = {
  children: ReactNode;
};  

const LoginProvider: React.FC<ProviderProps> = (providerProps) => {
  const {children} = providerProps;
  const [contextData, setContextData] = useState<LoginData['userLoginData']>({});    

  const handleDataChange = useCallback(
    (userLoginData: UserLoginData) => {
      setContextData(userLoginData);
    },
    [],
  );
    
  return (
      <LoginContext.Provider
        value={{
          userLoginData: contextData,
          setUserLoginData: handleDataChange,
        }}
      >
        {children}
      </LoginContext.Provider>
   );
};
  
export default LoginProvider;
  